export const OPEN_AI_HOST = "https://ai.quickmastery.org";
// export const OPEN_AI_HOST = "http://0.0.0.0:8787";

export const HEADRS = {
    "Content-Type": "application/json",
    "OpenAI-Beta": "assistants=v1" 
}
